import { z } from 'zod'

export const preferencesFormSchema = z.object({
	language: z.enum(['en', 'es', 'de', 'uk']).default('en'),
	date_format: z.enum(['US', 'EU']).default('EU'),
})
